<template>

<b-modal v-model="modalShow"
         centered
         :title="$t('labels.createUser')"
         hide-footer
         size="lg"
         no-close-on-backdrop>

    <b-overlay :show="loadingData" variant="transparent" no-wrap />

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('labels.firstName')">
              <validation-provider
                #default="{ errors }"
                name="firstName"
                rules="required"
              >
                <b-form-input
                  v-model="formData.firstName"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.firstName')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.lastName')">
              <validation-provider
                #default="{ errors }"
                name="lastName"
                rules="required"
              >
                <b-form-input
                  v-model="formData.lastName"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.lastName')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.userName')">
              <validation-provider
                #default="{ errors }"
                name="userName"
                rules="required"
              >
                <b-form-input
                  v-model="formData.userName"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.userName')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.email')">
              <validation-provider
                #default="{ errors }"
                name="email"
                rules="required|email"
              >
                <b-form-input
                  v-model="formData.email"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.email')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.password')">
              <validation-provider
                #default="{ errors }"
                name="password"
                :rules="{ required: true, min: 8 }"
              >
                <b-form-input
                  type="password"
                  v-model="formData.password"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.password')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.confirmPassword')">
              <validation-provider
                #default="{ errors }"
                name="Confirm Password"
                :rules="{ required: true, confirmed: 'password'}"
              >
                <b-form-input
                  type="password"
                  v-model="formData.confirm_password"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.confirmPassword')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.client')">
              <validation-provider
                #default="{ errors }"
                name="client"
                rules="required"
              >
                <v-select
                  v-model="formData.clientId"
                  :placeholder="$t('labels.client')"
                  label="name"
                  @input="getActiveCurrenciesClient(formData.clientId)"
                  :options="dataclients"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.role')">
              <validation-provider
                  #default="{ errors }"
                  name="role"
                  rules="required"
              >
              <v-select
                      v-model="formData.role"
                      :placeholder="$t('labels.role')"
                      label="name"
                      :options="dataRoles"
              />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.currencies')">
              <validation-provider
                      #default="{ errors }"
                      name="Currencies"
                      rules="required"
              >
                <v-select
                        v-model="formData.activeCurrencies"
                        :placeholder="formData.clientId ? $t('labels.currencies') : $t('labels.selectClient')"
                        label="name"
                        @input="setFormDefaultCurrency()"
                        multiple
                        :reduce="currency => currency._id"
                        :close-on-select="false"
                        :options="activeCurrenciesClients"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm"
            >
              {{$t('buttons.submit')}}
            </b-button>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>

</b-modal>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCardText, VBModal, BCard, BOverlay
} from 'bootstrap-vue'
import { required, integer, min } from '@validations'
import { mapActions  } from 'vuex'
import { BFormCheckbox } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BCard,
    vSelect,
    VBModal,
    BOverlay,
    ToastificationContent
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      modalShow: false,
      formData: {
        firstName: null,
        lastName: null,
        userName: null,
        password: null,
        email: null,
        clientId: null,
        role: [],
        confirm_password: null,
        activeCurrencies  : null,
        defaultCurency : null
      },
      required,
      integer,
      loadingData: false,
      dataclients: [],
      activeCurrenciesClients : [],
      dataRoles: [],
    }
  },

  methods: {
    ...mapActions("user", ["store", "users"]),
    ...mapActions("client", ["clients"]),
    ...mapActions("role", ["roles"]),
    ...mapActions("wallet", ["show"]),

    setFormDefaultCurrency(){
      if(Array.isArray(this.formData.activeCurrencies) && this.formData.activeCurrencies.length > 0){
        this.formData.defaultCurency = this.formData.activeCurrencies[0]
      }
    },

    async validationForm() {
      this.$refs.simpleRules.validate()
      .then(async (success) => {
        if (success) {
          try {
            this.loadingData = true
            let data = JSON.parse(JSON.stringify(this.formData))
            data.clientId = data.clientId._id
            await this.store(data)
            this.modalShow = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('labels.userAdded'),
                icon: "CheckCircleIcon",
                variant: "success",
              },
            });
            await this.users()
            this.resetFormData()
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('labels.errorAddingUser'),
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: `${error.message}`,
              },
            });
            console.log(error)
          }finally{
            this.loadingData = false
          }
        }
      })
      .catch((error) => {
        this.$swal({
          title: this.$t('labels.error'),
          text: error.message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },

    resetFormData(){
      this.formData = {
        firstName: null,
        lastName: null,
        userName: null,
        password: null,
        email: null,
        clientId: null,
        role: [],
        confirm_password: null,
      }
    },

    async getClients() {
      const clients = await this.clients()
      this.dataclients = [clients[0]]
    },

    async getRoles() {
      // this.roles().then((response)=>{
      //   this.dataRoles = response.roles
      // });
      const baseRoles = ['ROOT', 'SUPER_ADMIN','ADMIN','AGENT','CUSTOMER']
      let roles = []
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (userData.role.toLowerCase() == 'root' || userData.role.toLowerCase() == 'super_admin' )
        roles.push(baseRoles[1])
      else if (userData.role.toLowerCase() == 'admin' )
        roles.push(baseRoles[2],baseRoles[3],baseRoles[4])
      this.dataRoles =  roles
    },

    async getActiveCurrenciesClient(client){
      if (client){
        const currencies = client.currencies
        if (currencies)
          this.activeCurrenciesClients =  currencies.filter(currency => currency.active).map(currency => {
          return Object.assign({}, currency.currency)
        })

      } else {
        this.activeCurrenciesClients = []
      }
    }

  },

  created() {
    this.getClients();
    this.getRoles();
  },

}
</script>
